// npm
import Cookies from 'js-cookie';
import { Notice, Message } from 'iview';
// router
import router from '@/router';
// axios
import axios, {
  generateAuthHeaders,
  generateAuthPostConf,
  actionEnhancer,
  log,
  getIp
} from '@/utils/axios';

// constants
import {
  USER_REQUEST_MUTATION,
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  LOGIN_REQUEST_ACTION,
  LOGOUT_REQUEST_ACTION,
  AUTO_LOGIN_ACTION,
  UPDATE_PASSWORD_ACTION,
  UPDATE_PROFILE_ACTION,
  UPDATE_PROFILE_MUTATION,
  SIGNUP_VALIDATE_ACTION,
  SIGNUP_REQUEST_ACTION,
  GET_OTP_ACTION,
  UPDATE_OTP_COUNT_MUTATION,
  VERIFY_OTP_ACTION,
  FORGOT_PASSWORD_ACTION,
  FETCH_USER_ORDERS_ACTION,
  FETCH_ORDER_DETAIL_ACTION,
  SUBMIT_ADVISORY_ACTION,
  UPDATE_USER_ORDERS_MUTATION,
  UPDATE_USER_ADVISORY_MUTATION,
  UPDATE_ACTIVITY_RESERVECARINSU_MUTATION,
  UPDATE_ACTIVITY_RESERVEPETINSU_MUTATION,  //2022/01/13 Wen Add
} from './constants';

Notice.config({
  duration: 6
});

Message.config({
  duration: 15
});

const catchErrors = actionEnhancer(USER_REQUEST_MUTATION);

const login = catchErrors(async ({ commit, getters }, payload) => {
  const routeName = router.currentRoute.name;
  const ip = await getIp();
  const res = await axios.post('users/login', { ...payload, ip });
  const { success, message } = res.data;
  if (!success) {
    Message.error({ content: `${message}`, closable: true });
    return;
  }
  const {
    accessToken,
    shouldRemember,
    hasErrTransaction,
    ...profile
  } = res.data.result.profile;
  // update store
  commit(UPDATE_PROFILE_MUTATION, profile);
  commit(LOGIN_SUCCESS, { hasErrTransaction, ip });
  // set cookies
  const expires = shouldRemember ? 30 : 1;
  Cookies.set('accessToken', accessToken, { expires });
  // judge has order here
  const { isCheckouting, nowActivity } = getters.userInfo;
 // const { isCheckouting } = getters.userInfo;
  if (isCheckouting) return router.push({ name: 'checkoutInfo' });
  if (nowActivity.name) return router.push({ name: nowActivity.name });
  if (routeName.includes('signup')) return router.push({ name: 'signupSucc' });
  // redirect to index
  router.push('/');
});

const logout = catchErrors(async ({ commit }) => {
  const headers = generateAuthHeaders();
  const { currentRoute } = router;
  const res = await axios.get('users/logout', { headers });
  const { success, message } = res.data;
  if (!success) throw new Error(message);
  Cookies.remove('accessToken');
  commit(UPDATE_ACTIVITY_RESERVECARINSU_MUTATION); 
  commit(UPDATE_ACTIVITY_RESERVEPETINSU_MUTATION); //2022/01/13 Wen Add
  commit(LOGOUT_SUCCESS);
  commit(UPDATE_PROFILE_MUTATION, {});
  Notice.success({ title: '登出成功', desc: message });
  if (currentRoute.meta.requiresAuth) return router.push('/');
});

// auto login
const autoLogin = async ({ commit }) => {
  commit(USER_REQUEST_MUTATION, true);
  try {
    const ip = await getIp();
    // const headers = generateAuthHeaders();
    // const res = await axios.get('users/info', { headers });
    const config = generateAuthPostConf('users/info', { ip });
    const res = await axios(config);
    const { success, result } = res.data;
    if (!success) throw new Error();
    const { hasErrTransaction, ...profile } = result.profile;
    commit(UPDATE_PROFILE_MUTATION, profile);
    commit(LOGIN_SUCCESS, { hasErrTransaction, ip });
    commit(USER_REQUEST_MUTATION, false);
    return success;
  } catch (err) {
    Cookies.remove('accessToken');
    commit(USER_REQUEST_MUTATION, false);
  }
};

// update password
const updatePassword = catchErrors(async (context, payload) => {
  const url = 'users/updatepassword';
  const config = generateAuthPostConf(url, payload);
  const res = await axios(config);
  const { message, success } = res.data;
  if (!success) {
    Message.error({ content: `${message}，請再次確認舊密碼`, closable: true });
    return;
  }
  Message.success({ content: `${message} 下次登入請以新密碼登入`, closable: true });
  return success;
});

// update profile
// temprary code, need modify
const updateProfile = catchErrors(async ({ commit }, payload) => {
  const { handleReset, password, ...data } = payload;
  const url = 'users/update';
  const config = generateAuthPostConf(url, data);
  const res = await axios(config);
  const { success, result: { profile } } = res.data;

  if (!success) {
    Message.error({
      content: '親愛的會員您好，您輸入的資料有誤，麻煩您重新操作一次',
      closable: true
    });
    return;
  }

  commit(UPDATE_PROFILE_MUTATION, profile);
  Notice.success({ title: '親愛的會員您好', desc: '您的會員資料已成功更新' });
  return success;
});

// otp
const getOtp = catchErrors(async ({ commit, state, rootState }, { phoneNo, type = 'general' }) => {
  // (dev env setting test mode)
  const { NODE_ENV } = process.env;
  const testMode = NODE_ENV === 'development';
  const payload = testMode ? { testMode, phoneNo, type } : { phoneNo, type };
  // get otp request
  const res = await axios.post('util/GetOtp', payload);
  const { success, message, result: { otp } } = res.data;
  if (testMode) { console.log(otp.authCode); }
  // get otp fail
  if (!success) {
    commit(UPDATE_OTP_COUNT_MUTATION, 0);
    Message.warning({ content: `${message}`, closable: true });
    return;
  }
  if (type === 'checkout') {
    log({
      basketId: rootState.checkout.quotes.basketNum,
      webUserIp: state.ip,
      webControlCodeId: 'GOP',
      webProgramCodeId: 'CKV'
    });
  }
  commit(UPDATE_OTP_COUNT_MUTATION, otp.restOfCount);
  return success;
});

// verifyOtp payload: { authCode, phoneNo, type }
const verifyOtp = catchErrors(async ({ commit, state, rootState }, payload) => {
  const res = await axios.post('util/VerifyOtp', payload);
  const { success, message } = res.data;
  const { restOfCount } = state.otp;
  const content = restOfCount
    ? `${message} 麻煩您重新試一次。 若忘記驗證碼，還有 ${restOfCount} 次重新發送驗證碼機會`
    : `${message} 麻煩您重新試一次。 您今日重新發送驗證碼此數已達上限。`;
  if (!success) {
    Message.error({ content, closable: true });
    return;
  }
  if (payload.type === 'checkout') {
    log({
      basketId: rootState.checkout.quotes.basketNum,
      webUserIp: state.ip,
      webControlCodeId: 'VOP',
      webProgramCodeId: 'CKV'
    });
  }
  commit(UPDATE_OTP_COUNT_MUTATION, null);
  return success;
});

// signup validate
const signupValidate = catchErrors(async ({ dispatch }, payload) => {
  const { identityNo, phoneNo } = payload;
  // wait backend authentication first
  const authRes = await axios.post('users/validIdentity', { identityNo });
  const { success: authSucc, message: authMessage } = authRes.data;
  // authentication fail return notice error
  if (!authSucc) {
    Message.error({
      content: `${authMessage}`,
      closable: true
    });
    return;
  }
  const getOtpSucc = await dispatch(GET_OTP_ACTION, { phoneNo });
  // get otp result
  if (!getOtpSucc) return;
  router.push({ name: 'signupVerify', params: { payload } });
});

// signup user
const signup = catchErrors(async ({ dispatch }, payload) => {
  const type = 'general';
  const { authCode, ...profile } = payload;
  const { phoneNo } = profile;
  const verifySucc = await dispatch(VERIFY_OTP_ACTION, { authCode, phoneNo, type });
  if (!verifySucc) return;
  const res = await axios.post('users/register', { ...payload });
  const { success, message } = res.data;
  if (!success) { throw new Error(message); }
  const { identityNo, password } = profile;
  dispatch(LOGIN_REQUEST_ACTION, { identityNo, password, shouldRemember: false });
});

// forgot password
const forgotPassword = catchErrors(async (context, payload) => {
  const res = await axios.post('users/forgetPassword', payload);
  const { success, message } = res.data;
  if (!success) return message;
  return Notice.success({ title: '親愛的用戶您好', desc: message });
});

// fetch user orders
const fetchUserOrders = catchErrors(async ({ commit }) => {
  const url = 'orders/recentOrders';
  const config = generateAuthPostConf(url);
  const res = await axios(config);
  const { success, message, result: { orders, advisorys } } = res.data;
  if (!success) throw new Error(message);
  commit(UPDATE_USER_ORDERS_MUTATION, orders);
  commit(UPDATE_USER_ADVISORY_MUTATION, advisorys);
});

const fetchOrderDetail = catchErrors(async ({ getters, state }, order) => {
  const { orderId, ...orderDetail } = order;
  // const orderDetail = order;
  const { fullName, dateOfBirth, address } = getters.userInfo;
  const { profile: { identityNo, mail, phoneNo } } = state;
  const userProfile = { fullName, dateOfBirth, identityNo, phoneNo, mail, address };
  const url = 'orders/getOrderDetail';
  const config = generateAuthPostConf(url, { orderId });
  const res = await axios(config);
  const { result, success, message } = res.data;
  if (!success) throw new Error(message);
  return { ...result, userProfile, orderDetail };
});

const submitAdvisory = catchErrors(async ({ commit }, payload) => {
  //console.log(payload);
  // payload: { orderId, reviewContent }
  const url = 'Orders/Inquiry';
  const config = generateAuthPostConf(url, { ...payload, quesType: 'CPQ' });
  const res = await axios(config);
  const { success, message, result } = res.data;
  if (!success) throw new Error(message);
  const { advisory } = result;
  commit(UPDATE_USER_ADVISORY_MUTATION, advisory);
  return success;
});

export default {
  [LOGIN_REQUEST_ACTION]: login,
  [LOGOUT_REQUEST_ACTION]: logout,
  [AUTO_LOGIN_ACTION]: autoLogin,
  [UPDATE_PASSWORD_ACTION]: updatePassword,
  [UPDATE_PROFILE_ACTION]: updateProfile,
  [SIGNUP_VALIDATE_ACTION]: signupValidate,
  [SIGNUP_REQUEST_ACTION]: signup,
  [GET_OTP_ACTION]: getOtp,
  [VERIFY_OTP_ACTION]: verifyOtp,
  [FORGOT_PASSWORD_ACTION]: forgotPassword,
  [FETCH_USER_ORDERS_ACTION]: fetchUserOrders,
  [FETCH_ORDER_DETAIL_ACTION]: fetchOrderDetail,
  [SUBMIT_ADVISORY_ACTION]: submitAdvisory
};
